import { Gradient, GradientType } from 'types/pageTypes';

import { mixColors } from './color';
import { parseAngle } from './number';

/**
 * Get colour at bottom right corner of a page/box given the gradient properties
 *
 * @param gradientType Type of gradient (linear or radial)
 * @param colors Colors in the gradient - order based on CSS gradient syntax
 * @param angle Angle of gradient (for linear gradient only)
 * @returns Color at corner
 */
const getColorAtCorner = ({ type: gradientType, colors, angle }: Gradient) => {
  // Radial gradient, all corners have the same colour
  if (gradientType === GradientType.RadialGradient) {
    return colors[colors.length - 1];
  }

  let colorAtCorner = colors[0];
  if (gradientType === GradientType.LinearGradient) {
    if (!angle) return colors[0];

    const normalizedAngle = parseAngle(angle);
    const firstColor = colors[0];
    const lastColor = colors[colors.length - 1];
    if (normalizedAngle >= 0 && normalizedAngle <= 10) {
      // Gradient from bottom to top
      colorAtCorner = firstColor;
    } else if (normalizedAngle >= 80 && normalizedAngle <= 100) {
      // Gradient from left to right
      colorAtCorner = lastColor;
    } else if (normalizedAngle >= 170 && normalizedAngle <= 180) {
      // Gradient from top to bottom
      colorAtCorner = lastColor;
    } else if (normalizedAngle >= 260 && normalizedAngle <= 280) {
      // Gradient from right to left
      colorAtCorner = firstColor;
    } else {
      // Mix colours
      // Note: This is not the most accurate way but good enough for now
      colorAtCorner = mixColors(colors) || colors[0];
    }
  }

  return colorAtCorner;
};

export { getColorAtCorner };
